export default class ActiveToggle {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', this.handleClicks);
  }

  handleClicks(event) {
    const activeClass = 'is-active';
    const parent = event.target.parentNode.parentNode;

    event.preventDefault();

    if (!parent.classList.contains(activeClass)) {
      parent.classList.add(activeClass);
    } else {
      parent.classList.remove(activeClass);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ActiveToggle.js